import { idtype, image } from "querypieces";

export default `
  ...on pageBuilder_image_BlockType {
    ${idtype}
    ${image}
  }
`;
